const CommonModalStyle = theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
    },
    modalWrapper: {
        outline: "none",
        height: 640,
        width: 1100,
        left: 60,
        overflow:"hidden",
        position: "relative",
        border: "1px solid #979797",
        borderRadius: 4,
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFFFFF",
        boxShadow: "10px 10px 10px 0 rgba(0,0,0,0.5)"
    },
    modalHeader: {
        maxHeight: 24,
        display: "flex",
        flex: 1,
        background: 'var(--sea-grey)',
        color: 'var(--dark-grey)',
        fontFamily: "Proxima Nova",
        fontSize: 16,
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "20px",
        paddingLeft: 13,
        alignItems: "center"
    },
});

export const CommonModalStyleV2 = (theme) => ({
    modal: {
        display: 'flex',
        flexDirection: 'column',

        border: '1px solid var(--light-grey)',
        boxShadow: "10px 10px 10px 0 rgba(0,0,0,0.5)",
        borderRadius: 4,
        minWidth: 560,
        minHeight: 200,

        resize: 'horizontal',
        overflowY: 'hidden',

        position: 'absolute',
        top: '8px',
        left: '8px',

        background: 'var(--white)',
        transition: 'all',

        '& .modal-heading': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '8px',
            background: 'var(--sea-grey)',
            color: 'var(--dark-grey)',
            cursor: 'grab',
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'Proxima Nova',

            '& p': {
                margin: 0,
            },

            '&.grabbing': {
                cursor: 'grabbing'
            }
        },

        '& .modal-content': {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
        }
    }
});

export const CommonModalStyleV3 = (theme) => ({
    modal: {
        display: 'flex',
        flexDirection: 'column',

        minWidth: 560,
        minHeight: 560,

        resize: 'both',
        overflowY: 'hidden',
        zIndex: 1,

        position: 'absolute',
        top: '8px',
        left: '8px',

        transition: 'all',

        '& .modal-heading': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            cursor: 'grab',
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'Proxima Nova',

            '& p': {
                margin: 0,
            },

            '&.grabbing': {
                cursor: 'grabbing'
            }
        },

        '& .modal-content': {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            overflowY: 'auto',
            backgroundColor: 'var(--white-v2)',
        }
    }
});

export default CommonModalStyle;